import { Banner } from "@foodpilot/foods";
import { Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

export const SsqPostChangedWarnings = ({ sharedOrganizationNames = [] }: { sharedOrganizationNames?: string[] }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Banner
            variant={"themed"}
            colors={{
                color: theme.custom.orange[500],
                backgroundColor: theme.custom.orange[50],
                sideBorder: theme.custom.orange[500],
            }}
        >
            <Typography variant="body-semibold">
                {t(
                    "warnings.ssq_post_deletion",
                    "Proceeding further, you may delete answers of Questionnaire. Are you really sure ?",
                )}
            </Typography>
            {sharedOrganizationNames.length > 0 && (
                <Typography variant="body-semibold" display="block">
                    {t(
                        "warnings.ssq_post_deletion_shared_organizations",
                        "The answers entered by {{organizations}} will also be deleted.",
                        { organizations: sharedOrganizationNames.join(", ") },
                    )}
                </Typography>
            )}
        </Banner>
    );
};
